import Axios from "axios";
import { baseUrl } from "./api";

const axios = Axios.create({
    baseURL: baseUrl,
    headers: {
        Accept: 'application/json',
    },
});
export default axios;